export const errorsToIgnoreInSentry = [
  "[0365] ACF layout component not found in WpComponentRenderer.astro: section_card_component",
  "[0365] ACF layout component not found in WpComponentRenderer.astro: tailored_therapy_component",
  "'text/html' is not a valid JavaScript MIME type.",
  "AbortError: The play() request was interrupted by a call to pause()",
  "Array.from requires an array-like object - not null or undefined",
  "Cannot convert undefined or null to object",
  "Cannot read properties of null (reading '__transferData')",
  "Cannot read properties of null (reading 'index')",
  "Cannot read properties of null (reading 'removeItem')",
  "Cannot read properties of null (reading 'setItem')",
  "Cannot read properties of null (reading 'shadowRoot')",
  "Cannot read properties of undefined (reading 'audioVolumeChange')",
  "Cannot read properties of undefined (reading 'domInteractive')",
  "Cannot read properties of undefined (reading 'fireChangeEvent')",
  "Cannot read properties of undefined (reading 'fireEvent')",
  "Cannot read properties of undefined (reading 'fireReadyEvent')",
  "Cannot read properties of undefined (reading 'offsetHeight')",
  "Cannot read properties of undefined (reading 'parentNode')",
  "Cannot read properties of undefined (reading 'setCurrentPosition')",
  "Cannot read properties of undefined (reading 'setDefaultPosition')",
  "Cannot read properties of undefined (reading 'setMaxSize')",
  "Cannot read properties of undefined (reading 'setScreenSize')",
  "Cannot read properties of undefined (reading 'triggers')",
  "Cannot read property 'index' of null",
  "Cannot set properties of null (setting 'lastSetTimerId')",
  "Cannot set properties of undefined (setting 'lastSetTimerId')",
  "error loading dynamically imported module:",
  "Event `CustomEvent` (type=unhandledrejection) captured as promise rejection",
  "expected expression, got '='",
  "Failed to fetch",
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document",
  "Importing a module script failed",
  "Invalid call to runtime.sendMessage(). Tab not found",
  "is not defined",
  "Java bridge method invocation error",
  "Java object is gone",
  "Load failed",
  "n.showModal is not a function. (In 'n.showModal()', 'n.showModal' is undefined)",
  "NetworkError when attempting to fetch resource.",
  "No error message",
  "No identifiers allowed directly after numeric literal",
  "No media id provided",
  "Non-Error promise rejection captured with value:",
  "null is not an object (evaluating 'document.elementFromPoint(",
  "null is not an object (evaluating 'history.state.index')",
  "null is not an object (evaluating 'Object.keys(window.localStorage)')",
  "null is not an object (evaluating 'Object.prototype.hasOwnProperty.call(e,\"telephone\")')",
  "null is not an object (evaluating 'r.createElement')",
  "null is not an object (evaluating 'window.localStorage.__transferData')",
  "null is not an object (evaluating 'window.localStorage.setItem')",
  "Object captured as promise rejection with keys:",
  "r is not an Object. (evaluating 'e in r')",
  "scrollReadRandom(...) is not a function",
  "t is not a function",
  "t is not an Object. (evaluating 'n in t')",
  "The operation is insecure.",
  "undefined is not a function",
  "undefined is not an object (evaluating 'a.push')",
  "undefined is not an object (evaluating 'r.__transferData=!1')",
  "undefined is not an object (evaluating 's[e]')",
  "undefined is not an object (evaluating 'this._perf.domInteractive')",
  "undefined is not an object (evaluating 'window._vis_apm_lib')",
  "undefined is not an object (evaluating 'window.webkit.messageHandlers",
  "Unexpected token '='",
  "Unexpected token 'else'",
  "window.mainThread.webWorker.postMessage is not a function",
];

export const errorTypesToIgnoreInSentry = [
  "[3003] No media id provided",
  "<unknown>",
  "Error",
  "RangeError",
  "ReferenceError",
  "UnhandledRejection",
  "WP_COMPONENT_RENDERER_DEFAULT_ERROR",
];